/* eslint-disable operator-linebreak */

import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import PaymentController from '@/assets/controllers/PaymentController'
import LocaleController from '@/assets/controllers/LocaleController'
import requestModule from '@/assets/libs/requestModule.js'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
import MinPriceController from '@/assets/controllers/MinPriceController'

const EVENT_GET_PRODUCT_LIMIT = 'consumer/getProductLimit'
// Utilizado para os pagamentos com crédito pessoal e débito consumidor
let consumerData = {
    comandaNumber: null,
    saleCode: null,
    clientCodeComanda: null,
    consumerCodeComanda: null,
    clientCode: null,
    consumerCode: null,
    logged: false,
    consumerName: '',
    consumerId: '',
    consumersList: [],
    consumerDebit: {},
    personalCredit: {},
    typeSaleAllowed: {},
    consumerLogin: '',
    clientName: ''
}

// Utilizado para os pagamentos com crédito pessoal e débito consumidor que possuem forma de pagamento complementar (cartão ou pix)
let compPaymentData = {
    principalPaymentMethod: null,
    compPaymentMethod: null,
    compValue: null,
    NSU: null,
    date: null,
    hour: null,
    cupomFiscalSitef: null
}

const doRechargePayment = async function (paymentNumber, authHash, paymentMethod, orderCPF, date, hour, rechargeValue, rechargeFamily, cupomFiscalSitef) {
    let requestData = buildRequestData(rechargeValue, orderCPF, rechargeFamily, paymentMethod, paymentNumber, authHash)

    let rechargeResponse = await requestModule.postRequest('consumer/buyCredit', requestData)
        .then(res => res || {})
        .catch((e) => {})

    let rechargeSuccess = rechargeResponse && !rechargeResponse.error

    if (rechargeSuccess) {
        await confirmTef(date, hour, cupomFiscalSitef)
        return {
            success: true,
            data: rechargeResponse.data
        }
    } else {
        await cancelTef(date, hour, cupomFiscalSitef)
        return {
            success: false,
            data: []
        }
    }
}

const buildRequestData = function (rechargeValue, orderCPF, rechargeFamily, paymentMethod, paymentNumber, authHash) {
    let value = parseFloat(rechargeValue.replace(',', '.'))
    let storeInfo = Util.getGeneralInfo()
    let cpf = orderCPF || ''

    return {
        subsidiaryCode: storeInfo.subsidiaryCode,
        posCode: storeInfo.posCode,
        consumerId: consumerData.consumerId,
        cpf: cpf,
        clientCode: consumerData.clientCode,
        credit: [
            {
                productFamilyId: rechargeFamily,
                paymentId: paymentMethod.CDTIPORECE,
                nsu: paymentNumber,
                value: value,
                authHash: authHash
            }
        ]
    }
}

const confirmTef = async function (date, hour, cupomFiscalSitef = '') {
    await PaymentController.finishTransactionTEF(1, cupomFiscalSitef, date, hour)
    // console.log('Recarga de saldo realizada com sucesso')
    CartController.clearbandeiraCartao()
    CartController.clearDigitalWalletName()
}

const cancelTef = async function (date, hour, cupomFiscalSitef = '') {
    await PaymentController.finishTransactionTEF(0, cupomFiscalSitef, date, hour)
    let message = 'Transacao interrompida na rotina de recarga de saldo com estorno do valor'
    Util.logComunication('Exception ', {}, message)
    CartController.clearbandeiraCartao()
    CartController.clearDigitalWalletName()
}

const setCompPaymentData = (compPaymentMethod, compValue, NSU, date, hour, cupomFiscalSitef, authHash) => {
    compPaymentData.compPaymentMethod = compPaymentMethod
    compPaymentData.compValue = compValue
    compPaymentData.NSU = NSU
    compPaymentData.date = date
    compPaymentData.hour = hour
    compPaymentData.cupomFiscalSitef = cupomFiscalSitef
    compPaymentData.authHash = authHash
}

const setPrincipalPaymentMethod = (principalPaymentMethod) => {
    compPaymentData.principalPaymentMethod = principalPaymentMethod
}

const getCompPaymentData = () => {
    return compPaymentData
}

const clearCompPaymentData = () => {
    compPaymentData.principalPaymentMethod = null
    compPaymentData.compPaymentMethod = null
    compPaymentData.compValue = null
    compPaymentData.NSU = null
    compPaymentData.date = null
    compPaymentData.hour = null
    compPaymentData.cupomFiscalSitef = null
}

// Seta os dados do consumidor que fez login
const setConsumerData = (clientCode, consumerCode, consumerName = '', consumerDebit, personalCredit, consumerId, typeSaleAllowed, consumerLogin, clientName) => {
    consumerData.clientCode = clientCode
    consumerData.consumerCode = consumerCode
    consumerData.consumerName = consumerName
    consumerData.consumerId = consumerId
    consumerData.consumerDebit = consumerDebit
    consumerData.personalCredit = personalCredit
    consumerData.typeSaleAllowed = typeSaleAllowed
    consumerData.consumerLogin = consumerLogin
    consumerData.clientName = clientName
}

// Seta os dados do consumidor que estão na comanda, independente de estar logado no sistema ou não
const setConsumerDataComanda = (clientCodeComanda, consumerCodeComanda, comandaNumber, saleCode) => {
    consumerData.clientCodeComanda = clientCodeComanda
    consumerData.consumerCodeComanda = consumerCodeComanda
    consumerData.comandaNumber = comandaNumber
    consumerData.saleCode = saleCode
}

// Seta o saleCode da comanda (usado quando o consumidor não foi identificado na comanda)
const setSaleCodeComanda = (saleCode, comandaNumber) => {
    consumerData.saleCode = saleCode
    consumerData.comandaNumber = comandaNumber
}

const setConsumersList = (consumersList) => {
    consumerData.consumersList = consumersList
}

const getConsumerData = () => {
    return consumerData
}

const clearConsumerData = () => {
    if (consumerData.logged) {
        MinPriceController.setRecalculatedMinPrice('')
    }
    consumerData.comandaNumber = null
    consumerData.saleCode = null
    consumerData.clientCodeComanda = null
    consumerData.consumerCodeComanda = null
    consumerData.clientCode = null
    consumerData.consumerCode = null
    consumerData.logged = false
    consumerData.consumerName = ''
    consumerData.consumerId = ''
    consumerData.consumersList = []
    consumerData.consumerDebit = {}
    consumerData.personalCredit = {}
    consumerData.typeSaleAllowed = {}
    consumerData.consumerLogin = ''
    consumerData.clientName = ''
}

const userLogin = () => {
    consumerData.logged = true
    MinPriceController.setRecalculatedMinPrice(consumerData.clientCode + consumerData.consumerCode)
}

const userLogout = () => {
    consumerData.clientCode = null
    consumerData.consumerCode = null
    consumerData.consumerName = ''
    consumerData.consumerId = ''
    consumerData.consumerDebit = {}
    consumerData.personalCredit = {}
    consumerData.typeSaleAllowed = {}
    DifferentiatedPricesController.clearDiffPrices()
    MinPriceController.setRecalculatedMinPrice('')
    if (consumerData.logged) {
        consumerData.logged = false
    }
}

const userIsLogged = () => {
    return consumerData.logged
}

const comandaIdentificada = () => {
    return consumerData.clientCodeComanda != null && consumerData.consumerCodeComanda != null
}

const updateFamilyBalances = function (rechargeData) {
    let familyBalances = consumerData.personalCredit.familyBalances

    rechargeData.forEach(recharge => {
        let rechargedFamily = familyBalances.find(family => family.familyCode === recharge.productFamilyId)
        rechargedFamily.balance = recharge.currentBalance
    })
}

const treatFamilyBalances = (cart) => {
    let treatedFamilyBalances = []

    consumerData.personalCredit.familyBalances.forEach(family => {
        let familyBalance = family.balance
        let familyTotalCart = getFamilyTotalFromCart(family.familyCode, cart)
        let familyNextBalance = familyBalance - familyTotalCart

        treatedFamilyBalances.push({
            familyCode: family.familyCode,
            familyName: family.familyName,
            familyBalance: formatMoney(familyBalance),
            familyTotalCart: formatMoney(familyTotalCart),
            familyNextBalance: formatMoney(familyNextBalance),
            familyNextBalanceRaw: familyNextBalance,
            negativeBalance: family.negativeBalance
        })
    })

    return treatedFamilyBalances
}

const getFamilyTotalFromCart = (familyCode, cart) => {
    let familyTotal = 0
    let thisFamilyItems = []

    if (Util.isTapMode()) {
        thisFamilyItems = cart.filter(prod => prod.familyCode === familyCode)
    } else {
        thisFamilyItems = cart.filter(prod => prod.creditFamily === familyCode)
    }

    thisFamilyItems.forEach(prod => {
        let price = prod.totalItemPrice
        let quantity = 1

        if (!Util.isTapMode()) {
            quantity = prod.quantity ? prod.quantity : 1
        }

        familyTotal += price * quantity
    })

    return familyTotal
}

const getConsumerDebitBalance = () => {
    return consumerData.consumerDebit.balance
}

const canProceedToPayment = (method) => {
    let isPersonalCredit = method.IDTIPORECE === '9'
    let result
    if (isPersonalCredit) {
        result = checkPersonalCreditPayment()
    } else {
        result = checkConsumerDebitPayment()
    }
    return result
}

const checkPersonalCreditPayment = (method) => {
    let result = {
        canProceed: true,
        message: '',
        code: '000',
        showWarning: false,
        warningMessage: ''
    }

    let consumerData = getConsumerData()
    let cart = CartController.getCart()
    let cartTotal = CartController.getTotalPriceAsFloat()
    let allFamiliesSpentToday = 0
    let allFamiliesSpentMonthly = 0
    let showWarningLowBalance = consumerData.personalCredit.showWarningLowBalance
    let lowBalanceFamilies = []
    let allFamiliesBalance = 0
    let allFamiliesLimit = 0

    let checkedConsumer = consumerData.clientCode === consumerData.clientCodeComanda && consumerData.consumerCode === consumerData.consumerCodeComanda

    if (!checkedConsumer && Util.isTapMode()) {
        result.canProceed = false
        result.message = LocaleController.getString('cliente_login_nao_e_o_mesmo_comanda')
        result.code = '001'
        return result
    }

    for (let i = 0; i < consumerData.personalCredit.familyBalances.length; i++) {
        let currentFamily = consumerData.personalCredit.familyBalances[i]

        let familyMaxDailyValue = currentFamily.maxDailyValue
        let familySpentToday = currentFamily.spentToday
        let familyMaxMonthlyValue = currentFamily.maxMonthlyValue || null
        let familySpentMonthly = currentFamily.spentMonthly
        let familyTotalCart = getFamilyTotalFromCart(currentFamily.familyCode, cart)

        allFamiliesSpentToday += familySpentToday
        allFamiliesSpentMonthly += familySpentMonthly

        if (familyMaxMonthlyValue > 0 && (familyMaxMonthlyValue + familyTotalCart) > familyMaxMonthlyValue) {
            result.canProceed = false
            result.message = LocaleController.getString('valor_max_mensal_familia') + `${currentFamily.familyName}`
                + LocaleController.getString('foi_excedido_aspas')
            result.code = '002'
            return result
        }

        if (familyMaxDailyValue > 0 && familySpentToday + familyTotalCart > familyMaxDailyValue) {
            result.canProceed = false
            result.message = LocaleController.getString('valor_max_diario_familia') + `${currentFamily.familyName}`
                + LocaleController.getString('foi_excedido_aspas')
            result.code = '003'
            return result
        }

        let familyBalance = currentFamily.balance
        let negativeBalance = currentFamily.negativeBalance
        let methodBlockLowBalance = consumerData.personalCredit.blockLowBalance
        let balanceLimit = negativeBalance === 'S' ? methodBlockLowBalance : 0

        allFamiliesBalance += familyBalance
        allFamiliesLimit += balanceLimit

        if ((familyBalance - familyTotalCart) < balanceLimit) {
            result.canProceed = false
            result.message = LocaleController.getString('seu_saldo_familia_de_produtos') + `${currentFamily.familyName}`
                + LocaleController.getString('e_insuficiente')
            result.code = '004'
            return result
        }

        if (showWarningLowBalance != null && familyBalance - familyTotalCart < showWarningLowBalance) {
            lowBalanceFamilies.push(currentFamily.familyName)
        }
    }

    let methodMaxDailyValue = consumerData.personalCredit.maxDailyValue
    let methodMaxMonthlyValue = consumerData.personalCredit.maxMonthlyValue || null

    if (methodMaxMonthlyValue > 0 && (allFamiliesSpentMonthly + cartTotal) > methodMaxMonthlyValue) {
        result.canProceed = false
        result.message = LocaleController.getString('valor_max_diario_forma_pagamento') + `${formatMoney(methodMaxMonthlyValue)}`
        result.code = '005'
        return result
    }

    if (methodMaxDailyValue > 0 && allFamiliesSpentToday + cartTotal > methodMaxDailyValue) {
        result.canProceed = false
        result.message = LocaleController.getString('valor_max_diario_forma_pagamento') + `${formatMoney(methodMaxDailyValue)}`
        result.code = '006'
        return result
    }

    if (allFamiliesBalance - cartTotal < allFamiliesLimit) {
        result.canProceed = false
        // result.message = LocaleController.getString('saldo_insuficiente_completar_venda')
        result.message = LocaleController.getString('saldo_inferior') + `${formatMoney(allFamiliesLimit)}`
        result.code = '007'
        return result
    }

    if (lowBalanceFamilies.length > 0) {
        result.showWarning = true
        result.warningMessage = buildWarningMessage(lowBalanceFamilies, showWarningLowBalance)
    }

    return result
}

const checkConsumerDebitPayment = (method) => {
    let result = {
        canProceed: true,
        message: '',
        showWarning: false,
        warningMessage: ''
    }

    let consumerData = getConsumerData()
    let cartTotal = CartController.getTotalPriceAsFloat()
    let checkedConsumer = consumerData.clientCode === consumerData.clientCodeComanda && consumerData.consumerCode === consumerData.consumerCodeComanda

    if (!checkedConsumer && Util.isTapMode()) {
        result.canProceed = false
        result.message = LocaleController.getString('cliente_login_nao_e_o_mesmo_comanda')
        return result
    }

    let methodMaxDailyValue = consumerData.consumerDebit.maxDailyValue
    let spentToday = consumerData.consumerDebit.spentToday
    let methodMaxMonthlyValue = consumerData.consumerDebit.maxMonthlyValue
    let spentMonth = consumerData.consumerDebit.spentMonth

    if (methodMaxMonthlyValue > 0 && (spentMonth + cartTotal) > methodMaxMonthlyValue) {
        result.canProceed = false
        result.message = LocaleController.getString('valor_max_mensal_forma_pagamento') + `${formatMoney(methodMaxMonthlyValue)}`
        return result
    }

    if (methodMaxDailyValue > 0 && (spentToday + cartTotal) > methodMaxDailyValue) {
        result.canProceed = false
        result.message = LocaleController.getString('valor_max_diario_forma_pagamento') + `${formatMoney(methodMaxDailyValue)}`
        return result
    }

    let balance = consumerData.consumerDebit.balance
    let blockLowBalance = consumerData.consumerDebit.blockLowBalance
    if (blockLowBalance !== null && balance < blockLowBalance) {
        result.canProceed = false
        result.message = LocaleController.getString('saldo_inferior') + `${formatMoney(blockLowBalance)}`
        return result
    } else if (blockLowBalance !== null && (balance - cartTotal) < blockLowBalance) {
        result.canProceed = false
        result.message = LocaleController.getString('saldo_inferior') + `${formatMoney(blockLowBalance)}`
        return result
    }

    let showWarningLowBalance = consumerData.consumerDebit.showWarningLowBalance
    if (showWarningLowBalance != null && balance - cartTotal < showWarningLowBalance) {
        result.showWarning = true
        result.warningMessage = LocaleController.getString('seu_saldo_esta_abaixo_de') + `${formatMoney(showWarningLowBalance)}`
    }

    return result
}

const buildWarningMessage = (lowBalanceFamilies, showWarningLowBalance) => {
    let message = LocaleController.getString('seu_saldo')

    if (lowBalanceFamilies.length === 1) {
        message += LocaleController.getString('da_familia_de_produtos') + `"${lowBalanceFamilies[0]}"`
    } else {
        message += LocaleController.getString('das_familias_de_produtos')
        lowBalanceFamilies.forEach((familyName, index) => {
            if (index === 0) {
                message += `"${familyName}"`
            } else if (index === lowBalanceFamilies.length - 1) {
                message += LocaleController.getString('e') + `"${familyName}"`
            } else {
                message += `, "${familyName}"`
            }
        })
    }

    message += LocaleController.getString('esta_abaixo_de') + `${formatMoney(showWarningLowBalance)}`
    return message
}

const calculateExcessValue = (method) => {
    let isPersonalCredit = method.IDTIPORECE === '9'
    let excess
    if (isPersonalCredit) {
        excess = calculateExcessValueForPersonalCredit()
    } else {
        excess = calculateExcessValueForConsumerDebit()
    }
    return excess
}

const calculateExcessValueForPersonalCredit = () => {
    let excess = 0

    let consumerData = getConsumerData()
    let familyBalances = consumerData.personalCredit.familyBalances
    let cart = CartController.getCart()
    let cartTotal = CartController.getTotalPriceAsFloat()
    let allFamiliesSpentMonthly = 0
    let allFamiliesSpentToday = 0
    if (!familyBalances || familyBalances.length === 0) {
        excess = cartTotal
        return excess
    }
    let allFamiliesTotalCart = 0
    familyBalances.forEach(family => {
        let familyExcess = 0
        let familyBalanceExcess = 0
        let familyMaxMonthlyExcess = 0
        let familyMaxDailyExcess = 0

        let familyBalance = family.balance
        let negativeBalance = family.negativeBalance
        let methodBlockLowBalance = consumerData.personalCredit.blockLowBalance || 0
        let balanceLimit = negativeBalance === 'S' ? methodBlockLowBalance : 0
        let familyMaxMonthlyValue = family.maxMonthlyValue || null
        let familySpentMonthly = family.spentMonthly || 0
        let familyMaxDailyValue = family.maxDailyValue
        let familySpentToday = family.spentToday
        let familyTotalCart = getFamilyTotalFromCart(family.familyCode, cart)
        allFamiliesTotalCart += familyTotalCart
        allFamiliesSpentToday += familySpentToday
        allFamiliesSpentMonthly += familySpentMonthly
        if ((familyBalance - familyTotalCart) < balanceLimit) {
            familyBalanceExcess = balanceLimit - (familyBalance - familyTotalCart)
            familyExcess = familyBalanceExcess
        }

        if (familyMaxMonthlyValue > 0 && (familySpentMonthly + familyTotalCart) > familyMaxMonthlyValue) {
            familyMaxMonthlyExcess = (familySpentMonthly + familyTotalCart) - familyMaxMonthlyValue
            if (familyMaxMonthlyExcess > familyBalanceExcess) familyExcess = familyMaxMonthlyExcess
        }

        if (familyMaxDailyValue > 0 && familySpentToday + familyTotalCart > familyMaxDailyValue) {
            familyMaxDailyExcess = (familySpentToday + familyTotalCart) - familyMaxDailyValue
            if (familyMaxDailyExcess > familyExcess) familyExcess = familyMaxDailyExcess
        }
        // familyExcess = familyBalanceExcess > familyMaxDailyExcess ? familyBalanceExcess : familyMaxDailyExcess
        excess += familyExcess
    })

    let methodMaxMonthlyValue = consumerData.personalCredit.maxMonthlyValue
    let methodMaxMonthlyExcess = 0

    if (methodMaxMonthlyValue > 0 && allFamiliesSpentMonthly + cartTotal > methodMaxMonthlyValue) {
        methodMaxMonthlyExcess = (allFamiliesSpentMonthly + cartTotal) - methodMaxMonthlyValue
        if (methodMaxMonthlyExcess > excess) excess = methodMaxMonthlyExcess
    }

    let methodMaxDailyValue = consumerData.personalCredit.maxDailyValue
    let methodMaxDailyExcess = 0

    if (methodMaxDailyValue > 0 && allFamiliesSpentToday + cartTotal > methodMaxDailyValue) {
        methodMaxDailyExcess = (allFamiliesSpentToday + cartTotal) - methodMaxDailyValue
        if (methodMaxDailyExcess > excess) excess = methodMaxDailyExcess
    }

    // if (methodMaxDailyExcess > excess) excess = methodMaxDailyExcess

    /* if (Util.isTapMode()) {
        let serviceTax = CartController.getMainComandaAgregada().serviceTax
        excess += serviceTax
    } */

    if (allFamiliesTotalCart === 0) {
        excess = cartTotal
    }
    if (excess > cartTotal) excess = cartTotal

    return excess
}

const calculateExcessValueForConsumerDebit = () => {
    let excess = 0

    let consumerData = getConsumerData()
    let cartTotal = CartController.getTotalPriceAsFloat()

    let balance = consumerData.consumerDebit.balance
    let blockLowBalance = consumerData.consumerDebit.blockLowBalance
    if (blockLowBalance != null && balance < blockLowBalance) {
        // Se o saldo já está abaixo do limite, todo o valor da compra será excesso
        excess = cartTotal
    } else if (blockLowBalance != null && balance - cartTotal < blockLowBalance) {
        excess = blockLowBalance - (balance - cartTotal)
    }

    let maxMonthlyValue = consumerData.consumerDebit.maxMonthlyValue || null
    let spentMonth = consumerData.consumerDebit.spentMonth || 0
    let methodMaxmonthlyExcess = 0

    if (maxMonthlyValue > 0 && spentMonth + cartTotal > maxMonthlyValue) {
        methodMaxmonthlyExcess = (spentMonth + cartTotal) - maxMonthlyValue
    }
    if (methodMaxmonthlyExcess > excess) excess = methodMaxmonthlyExcess

    let methodMaxDailyValue = consumerData.consumerDebit.maxDailyValue
    let spentToday = consumerData.consumerDebit.spentToday
    let methodMaxDailyExcess = 0

    if (methodMaxDailyValue > 0 && spentToday + cartTotal > methodMaxDailyValue) {
        methodMaxDailyExcess = (spentToday + cartTotal) - methodMaxDailyValue
    }

    if (methodMaxDailyExcess > excess) excess = methodMaxDailyExcess

    /* if (Util.isTapMode()) {
        let serviceTax = CartController.getMainComandaAgregada().serviceTax
        excess += serviceTax
        a função getTotalPriceAsFloat ja pega o valor total com a taxa de serviço caso exista
    } */

    if (excess > cartTotal) excess = cartTotal

    return excess
}

const getProductsLimits = async (payments) => {
    const generalInfo = Util.getGeneralInfo(false)
    const payload = {
        subsidiaryCode: generalInfo.subsidiaryCode,
        clientCode: consumerData.clientCode,
        consumerCode: consumerData.consumerCode,
        items: getItemsCart(),
        payments: getPayments(payments)
    }

    let productsLimits = await requestModule.postRequest(EVENT_GET_PRODUCT_LIMIT, payload, 'post').then(r => r).catch(e => {
        return {
            error: true,
            message: e
        }
    })
    if (!productsLimits || productsLimits.error) {
        let message = 'Não foi possivel verificar o limite de produtos. ' + (productsLimits.error || '')
        Util.logComunication('getProductsLimits', {}, message)
        console.log(message)
        return false
    }
    productsLimits = (productsLimits && productsLimits.data && productsLimits.data.unavailable) || []
    updateProductsCart(productsLimits)
    if (productsLimits && productsLimits.length > 0) {
        return true
    }
    return false
}

function getPayments (payments) {
    if (!payments) {
        return []
    }
    if (!Array.isArray(payments)) payments = [].concat(payments)
    return payments.map((e) => ({ paymentCode: e.CDIDENTBUTON, paymentName: e.DSBUTTON, paymentId: e.IDTIPORECE }))
}

function getItemsCart () {
    let items = []
    let cart = CartController.getCart()
    cart.forEach((product) => {
        if ((product.price > 0) || (product.itemValue && product.itemValue > 0)) {
            items.push({
                productCode: product.productCode,
                productName: product.productName,
                creditFamily: product.creditFamily,
                quantity: Util.isTapMode() ? product.quantity : getQtty(product.quantity)
            })
        }
        if (Array.isArray(product.observations)) {
            product.observations.forEach(obs => {
                if (obs.price && obs.price > 0) {
                    items.push({
                        productCode: obs.obsProductCode,
                        productName: obs.obsName,
                        creditFamily: obs.creditFamily || '',
                        quantity: Util.isTapMode() ? (obs.quantity || 1) : getQtty(product.quantity, obs.quantity)
                    })
                }
            })
        }
        if (product.productCombo) {
            items = items.concat(getProdItemsCombo(product, product.productCombo))
        }
    })
    return items
}

function getProductsComboCombo (choosen) {
    let combos = []
    if (choosen) {
        Object.keys(choosen).forEach((e) => {
            choosen[e].forEach((c) => {
                combos.push(c)
            })
        })
    }
    return combos
}

function getProdItemsCombo (prod, combo) {
    let items = []
    combo.forEach(prodC => {
        let prodCquantity = getQtty(prod.quantity, prodC.quantity)
        if (prodC.price > 0) {
            items.push({
                productCode: prodC.subItemCode,
                productName: prodC.subItemName,
                creditFamily: prodC.subItemCreditFamily,
                quantity: Util.isTapMode() ? prodC.quantity : getQtty(prod.quantity, prodC.quantity)
            })
        }
        if (Array.isArray(prodC.observations)) {
            prodC.observations.forEach((obsC) => {
                if (obsC.price && obsC.price > 0) {
                    items.push({
                        productCode: obsC.subItemObsProductCode,
                        productName: obsC.subItemObsName,
                        creditFamily: obsC.creditFamily || '',
                        quantity: Util.isTapMode() ? (obsC.quantity || 1) : getQtty(prodCquantity, obsC.quantity)
                    })
                }
            })
        }
        let ccombos = prodC.choosen ? getProductsComboCombo(prodC.choosen) : []
        items = items.concat(getProdItemsCombo(prod, ccombos))
    })
    return items
}

function updateProductsCart (unavailableProducts) {
    let unavailableProductsObj = {}
    // unavailableProductsObj.hasProductUnavailableCombo = false
    unavailableProducts.forEach((e) => {
        unavailableProductsObj[e.productCode] = {
            quantityAvailable: e.quantityAvailable,
            quantity: 0
        }
    })
    let cart = CartController.getCart()
    cart.forEach((product) => {
        product.unavailable = false
        product.hasProductUnavailable = false
        if (unavailableProductsObj[product.productCode]) {
            product.unavailable = true
            product.quantityAvailable = unavailableProductsObj[product.productCode].quantityAvailable
            unavailableProductsObj[product.productCode].quantity += getQtty(product.quantity)
        }
        if (product.observations && product.observations.length > 0) {
            product.observations.forEach((obs) => {
                if (unavailableProductsObj[obs.obsProductCode]) {
                    product.hasProductUnavailable = true
                    obs.unavailable = true
                    obs.quantityAvailable = unavailableProductsObj[obs.obsProductCode].quantityAvailable
                    unavailableProductsObj[obs.obsProductCode].quantity += getQtty(product.quantity, obs.quantity)
                }
            })
        }
        if (product.productCombo) {
            product.productCombo.forEach((prodC) => {
                let prodcQtty = getQtty(product.quantity, prodC.quantity)
                prodC.hasProductUnavailable = false
                prodC.unavailable = false
                if (unavailableProductsObj[prodC.subItemCode]) {
                    product.hasProductUnavailable = true
                    prodC.hasProductUnavailable = true
                    prodC.unavailable = true
                    prodC.quantityAvailable = unavailableProductsObj[prodC.subItemCode].quantityAvailable
                    unavailableProductsObj[prodC.subItemCode].quantity += prodcQtty
                }
                if (prodC.observations && prodC.observations.length > 0) {
                    prodC.observations.forEach((obsC) => {
                        if (unavailableProductsObj[obsC.subItemObsProductCode]) {
                            product.hasProductUnavailable = true
                            prodC.hasProductUnavailable = true
                            obsC.unavailable = true
                            obsC.quantityAvailable = unavailableProductsObj[obsC.subItemObsProductCode].quantityAvailable
                            unavailableProductsObj[obsC.subItemObsProductCode].quantity += getQtty(prodcQtty, obsC.quantity)
                        }
                    })
                }
                if (prodC.choosen) {
                    Object.keys(prodC.choosen).forEach((e) => {
                        prodC.choosen[e].forEach((prodCC) => {
                            prodCC.unavailable = false
                            prodCC.hasProductUnavailable = false
                            let prodCcQtty = getQtty(prodcQtty, prodCC.quantity)
                            if (unavailableProductsObj[prodCC.subItemCode]) {
                                product.hasProductUnavailable = true
                                prodC.hasProductUnavailable = true
                                prodCC.unavailable = true
                                prodCC.quantityAvailable = unavailableProductsObj[prodCC.subItemCode].quantityAvailable
                                unavailableProductsObj[prodCC.subItemCode].quantity += prodCcQtty
                            }
                            if (prodCC.observations && prodCC.observations.length > 0) {
                                prodCC.observations.forEach((obsCc) => {
                                    if (unavailableProductsObj[obsCc.subItemObsProductCode]) {
                                        product.hasProductUnavailable = true
                                        prodC.hasProductUnavailable = true
                                        prodCC.hasProductUnavailable = true
                                        obsCc.unavailable = true
                                        obsCc.quantityAvailable = unavailableProductsObj[obsCc.subItemObsProductCode].quantityAvailable
                                        unavailableProductsObj[obsCc.subItemObsProductCode].quantity += getQtty(prodCcQtty, obsCc.quantity)
                                    }
                                })
                            }
                        })
                    })
                }
            })
        }
    })
    CartController.setUnavailableProducts(unavailableProductsObj)
}

function getQtty (qtProdFhather, qtProdSon) {
    qtProdFhather = qtProdFhather ? parseFloat(qtProdFhather) : parseFloat(1)
    qtProdSon = qtProdSon ? parseFloat(qtProdSon) : parseFloat(1)
    return qtProdFhather * qtProdSon
}
function formatMoney (value) {
    return `R$ ${parseFloat(value).toFixed(2).replace('.', ',')}`
}

const loginWithBadge = async (badgeCode) => {
    /* monta o payload especifico para login com cracha */
    let requestObject = {
        consumerId: badgeCode,
        password: '',
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        storeCode: Util.getGeneralInfo()['storeCode'],
        lockKeyboardCons: 'S'
    }
    let loginResponse = await requestModule.postRequest('consumer/login', requestObject).then(res => res || {}).catch((e) => { })
    return handleLoginResponse(loginResponse)
}

const loginWithFaceRecognition = async (rawConsumer) => {
    /* monta o payload especifico para login facial */
    let params = (rawConsumer || '').split('|')
    let cdCliente = params[0] || ''
    let cdConsumidor = params[1] || ''
    let requestObject = {
        isFacialLogin: 'S',
        clientCode: cdCliente,
        consumerCode: cdConsumidor,
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        storeCode: Util.getGeneralInfo()['storeCode']
    }
    let loginResponse = await requestModule.postRequest('consumer/login', requestObject).then(res => res || {}).catch((e) => { })
    return handleLoginResponse(loginResponse)
}

const loginWithPassword = async (userName, password) => {
    /* monta o payload especifico para login com senha */
    let requestObject = {
        consumerId: userName,
        password: password,
        subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
        storeCode: Util.getGeneralInfo()['storeCode'],
        lockKeyboardCons: 'N'
    }
    let loginResponse = await requestModule.postRequest('consumer/login', requestObject).then(res => res || {}).catch((e) => { })
    return handleLoginResponse(loginResponse)
}

const handleLoginResponse = async function (loginResponse) {
    let response = {
        success: false,
        message: ''
    }
    if (loginResponse && !loginResponse.error) {
        try {
            let clientCode = loginResponse.data.consumer.clientCode
            let consumerCode = loginResponse.data.consumer.consumerCode
            let consumerName = loginResponse.data.consumer.consumerName
            let consumerId = loginResponse.data.consumer.consumerId
            let typeSaleAllowed = loginResponse.data.consumer.typeSaleAllowed
            let clientName = loginResponse.data.consumer.clientName || ''
            let consumerDebit = loginResponse.data.consumer.consumerDebit || {}
            let personalCredit = loginResponse.data.consumer.personalCredit || {}

            setConsumerData(clientCode, consumerCode, consumerName,
                consumerDebit, personalCredit, consumerId, typeSaleAllowed, consumerId, clientName
            )
            userLogin()
            await DifferentiatedPricesController.fetchDiffPrices(clientCode, consumerCode)
            MinPriceController.setRecalculatedMinPrice()
            response.success = true
            response.message = 'Login realizado com sucesso'
        } catch (error) {
            console.log('Nao foi possivel recuperar os dados do consumidor')
            console.log(error)
            response.success = false
            response.message = 'Nao foi possivel recuperar os dados do consumidor'
        }
    }
    if (loginResponse && loginResponse.error) {
        response.success = false
        response.message = loginResponse.message
        let message = loginResponse.message
        if (!messageToIgnore.includes(message)) {
            Util.showInfoModal(loginResponse.message)
        }
    }
    return response
}

const messageToIgnore = [
    'Erro ao realizar o login do consumidor. Consumidor não encontrado!',
    'Erro ao realizar o login do consumidor. Senha incorreta.'
]

export default {
    setConsumerData,
    setConsumerDataComanda,
    setSaleCodeComanda,
    setConsumersList,
    getConsumerData,
    clearConsumerData,
    userLogin,
    userLogout,
    userIsLogged,
    comandaIdentificada,
    treatFamilyBalances,
    canProceedToPayment,
    calculateExcessValue,
    setCompPaymentData,
    setPrincipalPaymentMethod,
    getCompPaymentData,
    clearCompPaymentData,
    getConsumerDebitBalance,
    doRechargePayment,
    updateFamilyBalances,
    getProductsLimits,
    loginWithBadge,
    loginWithPassword,
    loginWithFaceRecognition
}



// WEBPACK FOOTER //
// ./src/assets/controllers/IdentifiedConsumerController.js